export type ErrorCategory =
  | 'network'
  | 'unauthorized'
  | 'forbidden'
  | 'not-found'
  | 'validation'
  | 'conflict'
  | 'rate-limited'
  | 'server'
  | 'unknown';

export interface AppError {
  category: ErrorCategory;
  message?: string; // For validation messages or specific overrides
  entity?: string; // For not-found
}

export const ERROR_CATALOG: Record<ErrorCategory, (entity?: string) => string> = {
  network: () => "Couldn't reach the server. Check your connection.",
  unauthorized: () => "Your session expired. Sign in again.",
  forbidden: () => "You don't have access to this.",
  'not-found': (entity = 'item') => `This ${entity} no longer exists.`,
  validation: () => "Please check the form for errors.",
  conflict: () => "This was changed by someone else. Reload to see the latest.",
  'rate-limited': () => "Too many requests. Try again in a moment.",
  server: () => "Something went wrong on our end. We've been notified.",
  unknown: () => "Something went wrong on our end. We've been notified.",
};

export function getErrorMessage(error: AppError): string {
  if (error.message && error.category === 'validation') return error.message;
  return ERROR_CATALOG[error.category]?.(error.entity) || ERROR_CATALOG.unknown();
}
